module.exports = __webpack_public_path__ + "img/banner2_4_kr.f945b1f4.png";